<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Tenan/Detail</h1>
      </div>
      <div class="flex">
        <div @click="showModalDestroy" class="mr-5 cursor-pointer">
          <fas icon="trash-alt" class="text-red-600 text-2xl" />
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Avatar (1020 px X 1020 px)</div>
            <div @click="showModalUpdateAvatar" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              v-if="content.tenant_image"
              class="w-52 h-52 mr-3"
              :src="content.tenant_image"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Denah Location (1200 px X 500 px)
            </div>
            <div @click="showModalUpdateLocation" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              class="w-1/2 mr-3 h-52"
              :src="content.tenant_denah_position"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Content</div>
            <div
              @click="showModalEditContentTenant"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">Name</div>
          <div v-if="content.tenant_name !== ''" class="ml-5">
            {{ content.tenant_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Description</div>
          <div
            v-if="content.tenant_description !== ''"
            class="ml-5"
            v-html="content.tenant_description"
          ></div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Telephone</div>
          <div v-if="content.tenant_telephone !== ''" class="ml-5">
            {{ content.tenant_telephone }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Floor Location</div>
          <div v-if="content.floor_name !== ''" class="ml-5">
            {{ content.floor_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Category</div>
          <div v-if="content.tenan_category_name !== ''" class="ml-5">
            {{ content.tenan_category_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Website</div>
          <div v-if="content.tenant_website !== ''" class="ml-5">
            {{ content.tenant_website }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Website Mall To Go</div>
          <div v-if="content.tenant_website_mall_to_go !== ''" class="ml-5">
            {{ content.tenant_website_mall_to_go }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Promotions</div>
          </div>
          <div
            v-for="pr in content.promo"
            :key="pr.id"
            class="rounded-md p-2 mb-4 border-b-2"
          >
            <div class="font-semibold">Category</div>
            <div v-if="pr.promotion_category_name !== ''" class="ml-5">
              {{ pr.promotion_category_name }}
            </div>
            <div v-else class="ml-5">-</div>

            <div class="font-semibold">Promotion Name</div>
            <div
              v-if="pr.promotion_name !== '' || pr.promotion_name !== undefined"
              class="ml-5"
            >
              <router-link
                :to="'/promo/' + pr.id"
                class="bg-purple-400 border-2 p-2 text-white font-bold rounded-md"
              >
                {{ pr.promotion_name }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Warning !</div>
            <div class="">
              <button
                @click.self="showModalDestroy"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            Are you sure to Continue delete this Tenant
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="destroyTenant"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalTenantInfo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditContentTenant"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit Content</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Status</label
                >
                <div class="flex flex-row items-center h-9 mb-5">
                  <div
                    class="relative cursor-pointer"
                    @click="update.is_active = !update.is_active"
                  >
                    <div
                      class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                      :class="{ 'bg-app-default': update.is_active }"
                    ></div>
                    <div
                      class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                      :class="{ 'translate-x-6': update.is_active }"
                    ></div>
                  </div>
                </div>
              </div>

              <Select
                :selectItem="selectItem"
                :data="dropDown.dataSelect"
                :open="dropDown.isOpen"
                :selected="dropDown.selected"
                :openSelect="openSelect"
                :id="update.tenan_category_id"
                :isError="errors.tenan_category_id"
                :errorMessage="errors.tenan_category_id_msg"
                :title="dropDown.title"
              />

              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Name</label
                >
                <input
                  v-model="update.tenant_name"
                  @keyup="tenantNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_name_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Telephone</label
                >
                <input
                  v-model="update.tenant_telephone"
                  @keyup="tenantTelephoneChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_telephone
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Telephone"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_telephone_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Email</label
                >
                <input
                  v-model="update.tenant_email"
                  @keyup="tenantEmailChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_email
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Email"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_email_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Website</label
                >
                <input
                  v-model="update.tenant_website"
                  @keyup="tenantWebsiteChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_website
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Website"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_website_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Website Mall To GO</label
                >
                <input
                  v-model="update.tenant_website_mall_to_go"
                  @keyup="tenantWebsiteMallToGoChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_website_mall_to_go
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Website Mall To GO"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_website_mall_to_go_msg }}
                </div>
              </div>

              <Select
                :selectItem="floorSelectItem"
                :data="floorDropDown.dataSelect"
                :open="floorDropDown.isOpen"
                :selected="floorDropDown.selected"
                :openSelect="floorOpenSelect"
                :id="update.tenant_floor_location"
                :isError="errors.tenant_floor_location"
                :errorMessage="errors.tenant_floor_location_msg"
                :title="floorDropDown.title"
              />

              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Description</label
                >
                <!-- <textarea
                  v-model="update.tenant_description"
                  @keyup="tenantDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.tenant_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="tenantDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.tenant_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.tenant_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_description_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditContentTenant"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateInfoTenant"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditContentTenant"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update avatar -->
    <div
      v-if="modalUploadAvatar"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 450px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Avatar (1020 px X 1020 px)
            </div>
            <div class="">
              <button
                @click.self="showModalUpdateAvatar"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 rounded-lg"
                :class="[
                  errors.tenant_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewTenantAvatar"
              >
                <input
                  type="file"
                  accept="image/jpeg, image/jpg"
                  @change="previewTenantAvatar"
                  id="avatar_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="avatar.previewAvatar"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeAvatarPreview()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewAvatar"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewAvatar === null"
                    v-cloak
                    @click="chooseFileAvatar()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.tenant_image_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalUpdateAvatar"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateTenantAvatar"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalUpdateAvatar"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Location -->
    <div
      v-if="modalDenahLocation"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Denah Location (1200 px X 500 px)
            </div>
            <div class="">
              <button
                @click.self="showModalUpdateLocation"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.tenant_denah_position
                    ? 'border-red-400'
                    : 'border-black',
                ]"
                @drop="previewDenahLocation"
              >
                <input
                  type="file"
                  accept="image/jpeg, image/jpg"
                  multiple="multiple"
                  @change="previewDenahLocation"
                  id="location_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="location.previewLocation"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeLocationleFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="location.previewLocation"
                      class="w-full h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="location.previewLocation === null"
                    v-cloak
                    @click="chooseLocationleFile()"
                    class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.tenant_denah_position_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalUpdateLocation"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="avatar.previewLocation === null"
                @click="updateDenahLocation"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalUpdateLocation"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import Select from "../../components/Select.vue";
import BackButton from "../../components/BackButton.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
import CKEditor from "../../components/CKEditor.vue";
export default {
  name: "TenantDetail",
  components: {
    Select,
    Warning,
    BackButton,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      content: {},
      createdAt: null,
      modalDestroy: false,
      modalTenantInfo: false,
      modalUploadAvatar: false,
      errors: {
        user_id: false,
        tenant_image: false,
        tenant_denah_position: false,
        tenan_category_id: false,
        tenant_name: false,
        tenant_telephone: false,
        tenant_email: false,
        tenant_website: false,
        tenant_website_mall_to_go: false,
        tenant_description: false,
        tenant_floor_location: false,
        is_active: false,
        user_id_msg: "",
        tenant_image_msg: "",
        tenant_denah_position_msg: "",
        tenan_category_id_msg: "",
        tenant_name_msg: "",
        tenant_telephone_msg: "",
        tenant_email_msg: "",
        tenant_website_msg: "",
        tenant_website_mall_to_go_msg: "",
        tenant_description_msg: "",
        tenant_floor_location_msg: "",
        is_active_msg: "",
      },
      dropDown: {
        isOpen: false,
        dataSelect: [],
        title: "Tenant Category",
        selected: "pilih sesuatu",
      },
      floorDropDown: {
        isOpen: false,
        dataSelect: [],
        title: "Floor Location",
        selected: "pilih sesuatu",
      },
      avatar: {
        previewAvatar: null,
        fileAvatar: null,
      },
      location: {
        previewLocation: null,
        fileLocation: null,
      },
      update: {
        is_active: true,
        tenant_name: "",
        tenant_telephone: "",
        tenant_email: "",
        tenant_website: "",
        tenant_website_mall_to_go: "",
        tenant_description: "",
        tenant_floor_location: null,
        tenan_category_id: null,
      },
      saveButton: "Save",
      deleteButton: "Delete",
      modalDenahLocation: false,
    };
  },
  methods: {
    tenantNameChange: function(e) {
      this.update.tenant_name = e.target.value;
      this.errors.tenant_name = false;
      this.errors.tenant_name_msg = "";
    },
    tenantTelephoneChange: function(e) {
      this.update.tenant_telephone = e.target.value;
      this.errors.tenant_telephone = false;
      this.errors.tenant_telephone_msg = "";
    },
    tenantEmailChange: function(e) {
      this.update.tenant_email = e.target.value;
      this.errors.tenant_email = false;
      this.errors.tenant_email_msg = "";
    },
    tenantWebsiteChange: function(e) {
      this.update.tenant_website = e.target.value;
      this.errors.tenant_website = false;
      this.errors.tenant_website_msg = "";
    },
    tenantWebsiteMallToGoChange: function(e) {
      this.update.tenant_website_mall_to_go = e.target.value;
      this.errors.tenant_website_mall_to_go = false;
      this.errors.tenant_website_mall_to_go_msg = "";
    },
    tenantDescriptionChange: function() {
      // this.update.tenant_description = e.target.value;
      this.errors.tenant_description = false;
      this.errors.tenant_description_msg = "";
    },
    openSelect: function() {
      this.dropDown.isOpen = !this.dropDown.isOpen;
    },
    selectItem: function(val) {
      this.dropDown.isOpen = false;
      this.update.tenan_category_id = val.id;
      this.errors.tenan_category_id = false;
      this.errors.tenan_category_id_msg = "";
      this.dropDown.selected = val.name;
    },
    floorOpenSelect: function() {
      this.floorDropDown.isOpen = !this.floorDropDown.isOpen;
    },
    floorSelectItem: function(val) {
      this.floorDropDown.isOpen = false;
      this.update.tenant_floor_location = val.id;
      this.errors.tenant_floor_location_msg = "";
      this.errors.tenant_floor_location = false;
      this.floorDropDown.selected = val.name;
    },
    chooseFileAvatar: function() {
      document.getElementById("avatar_file").click();
    },
    chooseLocationleFile: function() {
      document.getElementById("location_file").click();
    },
    removeAvatarPreview: function() {
      this.avatar.fileAvatar = null;
      this.avatar.previewAvatar = null;
    },
    removeLocationleFile: function() {
      this.location.previewLocation = null;
      this.location.fileLocation = null;
    },
    previewTenantAvatar: function(event) {
      let input = event.target;
      if (input.files[0]) {
        let type = "image/jpeg, image/jpg";
        if (!type.includes(input.files[0].type)) {
          this._error("Please use jpeg or jpg image");
          return;
        }
      }
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewAvatar = e.target.result;
        };
        this.avatar.fileAvatar = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.tenant_image = false;
      this.errors.tenant_image_msg = "";
    },
    previewDenahLocation: function(event) {
      let input = event.target;
      if (input.files[0]) {
        let type = "image/jpeg, image/jpg";
        if (!type.includes(input.files[0].type)) {
          this._error("Please use jpeg or jpg image");
          return;
        }
      }
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.location.previewLocation = e.target.result;
        };
        this.location.fileLocation = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.tenant_denah_position = false;
      this.errors.tenant_denah_position_msg = "";
    },
    showModalDestroy: function() {
      this.modalDestroy = !this.modalDestroy;
    },
    showModalUpdateAvatar: function() {
      this.saveButton = "Save";
      this.avatar.fileAvatar = null;
      this.avatar.previewAvatar = null;
      this.modalUploadAvatar = !this.modalUploadAvatar;
    },
    showModalUpdateLocation: function() {
      this.saveButton = "Save";
      this.location.previewLocation = null;
      this.location.fileLocation = null;
      this.modalDenahLocation = !this.modalDenahLocation;
    },
    showModalEditContentTenant: function() {
      this.update.is_active = this.content.is_active;
      this.update.tenant_name = this.content.tenant_name;
      this.update.tenant_telephone = this.content.tenant_telephone;
      this.update.tenant_email = this.content.tenant_email;
      this.update.tenant_website = this.content.tenant_website;
      this.update.tenant_website_mall_to_go = this.content.tenant_website_mall_to_go;
      this.update.tenant_description = this.content.tenant_description;
      this.update.tenant_floor_location = this.content.tenant_floor_location;
      this.floorDropDown.selected = this.content.floor_name;
      this.update.tenan_category_id = this.content.tenan_category_id;
      this.dropDown.selected = this.content.tenan_category_name;
      this.modalTenantInfo = !this.modalTenantInfo;
    },
    destroyTenant: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.content.id,
          }),
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.$router.push(`/tenant`);
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    updateTenantAvatar: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("tenant_image", this.avatar.fileAvatar);
      formdata.append("id", this.content.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/update-avatar`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "tenant_image") {
                this.errors.tenant_image = true;
                this.errors.tenant_image_msg = item.message;
              }
              if (item.key === "user_id") {
                this.errors.user_id = true;
                this.errors.user_id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalUploadAvatar = false;
        this.saveButton = "Save";
        this.detailTenant();
        this._success("Data updated.");
      } catch (err) {
        this.modalUploadAvatar = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateDenahLocation: async function() {
      this.saveButton = "Loading...bos";
      let formdata = new FormData();
      formdata.append("tenant_denah_position", this.location.fileLocation);
      formdata.append("id", this.content.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/update-avatar-location`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "tenant_denah_position") {
                this.errors.tenant_denah_position = true;
                this.errors.tenant_denah_position_msg = item.message;
              }
              if (item.key === "user_id") {
                this.errors.user_id = true;
                this.errors.user_id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalDenahLocation = false;
        this.saveButton = "Save";
        this.detailTenant();
        this._success("Data updated.");
      } catch (err) {
        this.modalDenahLocation = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateInfoTenant: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.content.id,
            user_id:
              this.$store.state.profile.id === undefined
                ? 1
                : this.$store.state.profile.id,
            is_active: this.update.is_active,
            tenant_name: this.update.tenant_name,
            tenant_telephone: this.update.tenant_telephone,
            tenant_email: this.update.tenant_email,
            tenant_website: this.update.tenant_website,
            tenant_website_mall_to_go: this.update.tenant_website_mall_to_go,
            tenant_description: this.update.tenant_description,
            tenant_floor_location: this.update.tenant_floor_location,
            tenan_category_id: this.update.tenan_category_id,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "user_id") {
                this.errors.user_id = true;
                this.errors.user_id_msg = item.message;
              }
              if (item.key === "tenan_category_id") {
                this.errors.tenan_category_id = true;
                this.errors.tenan_category_id_msg = item.message;
              }
              if (item.key === "tenant_name") {
                this.errors.tenant_name = true;
                this.errors.tenant_name_msg = item.message;
              }
              if (item.key === "tenant_telephone") {
                this.errors.tenant_telephone = true;
                this.errors.tenant_telephone_msg = item.message;
              }
              if (item.key === "tenant_email") {
                this.errors.tenant_email = true;
                this.errors.tenant_email_msg = item.message;
              }
              if (item.key === "tenant_website") {
                this.errors.tenant_website = true;
                this.errors.tenant_website_msg = item.message;
              }
              if (item.key === "tenant_website_mall_to_go") {
                this.errors.tenant_website_mall_to_go = true;
                this.errors.tenant_website_mall_to_go_msg = item.message;
              }
              if (item.key === "tenant_description") {
                this.errors.tenant_description = true;
                this.errors.tenant_description_msg = item.message;
              }
              if (item.key === "tenant_floor_location") {
                this.errors.tenant_floor_location = true;
                this.errors.tenant_floor_location_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalTenantInfo = false;
        this.detailTenant();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalTenantInfo = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    handleImages(files) {
      this.images = files;
    },
    detailTenant: async function() {
      try {
        let res = await fetch(`${API}v1/tenant/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.content = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findCategoryTenant: async function() {
      try {
        let res = await fetch(`${API}v1/tenant-category`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.tenan_category_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    findFloors: async function() {
      try {
        let res = await fetch(`${API}v1/floors`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.floorDropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.floor_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailTenant();
    this.findCategoryTenant();
    this.findFloors();
  },
};
</script>
